import axios from "axios";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { updateLanguage } from "../redux/user_reducer";
// import {uuid}
// import 
function HighlightTextInParagraph({ paragraph }) {
   // Regex for **bold** text (two asterisks)
   const  italicRegex= /\*\*(.*?)\*\*/g;
   // Regex for *italic* text (single asterisk)
   // This needs to be more specific to avoid matching the **bold** pattern's single asterisks.
   // We look for a single asterisk not followed or preceded by another asterisk.
   // Or, a simpler approach: process bold first, then italic on the result.
   const  boldRegex= /\*(.*?)\*/g; // Matches *text* but not **text**
 
   // Step 1: Process bold text first
   let processedElements = [];
   let lastIndex = 0;
   let match;
  // console.log(paragraph)
   while ((match = italicRegex.exec(paragraph)) !== null) {
     const capturedText = match[1];
     const startIndex = match.index;
     const endIndex = italicRegex.lastIndex;
 
     // Add text before the bold match
     if (startIndex > lastIndex) {
      // console.log(match)
       processedElements.push(paragraph.substring(lastIndex, startIndex));
     }
 
     // Add the <strong> tag
     processedElements.push(<em key={`italic-${startIndex}`}>{capturedText}</em>);
     lastIndex = endIndex;
   }
   // Add any remaining text after the last bold match
   if (lastIndex < paragraph.length) {
     processedElements.push(paragraph.substring(lastIndex));
   }
 
   // Step 2: Now, process the elements for italic text
   // We need to iterate over `processedElements` and apply italic regex only to strings
   const finalElements = [];
//  console.log(processedElements)
   processedElements.forEach((element, index) => {
     // If it's already a React element (like <strong>), just push it directly
     if (React.isValidElement(element)) {
       finalElements.push(element);
       return; // Skip to the next element
     }
 
     // If it's a string, we need to process it for italics
     const currentString = element;
     let italicLastIndex = 0;
     let italicMatch;
     const tempItalicParts = [];
 
     // Reset the regex state for this string
     italicRegex.lastIndex = 0;
    //  console.log(currentString)
     while ((italicMatch = boldRegex.exec(currentString)) !== null) {
      
       const capturedText = italicMatch[1];
       const startIndex = italicMatch.index;
       const endIndex = boldRegex.lastIndex;
 
       // Add text before the italic match
       if (startIndex > italicLastIndex) {
         tempItalicParts.push(currentString.substring(italicLastIndex, startIndex));
       }
 
       // Add the <em> tag
       tempItalicParts.push(<strong key={`bold-${startIndex}`}>{capturedText}</strong>);
       italicLastIndex = endIndex;
     }
 
     // Add any remaining text after the last italic match in this string
     if (italicLastIndex < currentString.length) {
       tempItalicParts.push(currentString.substring(italicLastIndex));
     }
 
     // Add all parts (strings and <em> elements) from this string processing to finalElements
     // IMPORTANT: Ensure each string part is wrapped in a span for React's rendering
     tempItalicParts.forEach((part, partIndex) => {
       if (React.isValidElement(part)) {
         finalElements.push(part);
       } else {
         finalElements.push(<span key={`str-${index}-${partIndex}`}>{part}</span>);
       }
     });
   });
  
  // React can directly render an array of valid children (strings, numbers, React elements).
  // No need for an extra `.map()` if the `elements` array already contains what you want to render.
  return (
   
    finalElements
    
  );
}

export const TranslateText =({children,sx,style,component,to,target,onClick,color} ) => {
const language=useSelector(state=>state.user.language)
const [astric,setAstric]=useState(false)
const [quot,setQuot]=useState(false)
const dispatch=useDispatch()
// console.log("children text",children,sx,language)
// console.log("?????????????????????????????????????????????")
let [translatedText,setTranslatedText]=useState("")
let storedlan=localStorage.getItem('language')
let [lan,setLan]=useState('en')
// useEffect(()=>{
//   if (language==storedlan){
//       setLan(language)
//   }
//   else if (storedlan){
//     setLan(storedlan)
//     dispatch(updateLanguage(storedlan))
   
// }

// },[language,storedlan])

useEffect(()=>{
    if (language!='en'){
    // console.log(children)
        let text=React.Children.toArray(children).map((child) => {
          // console.log(child)
         if( typeof (child) === 'string' ) {
          return child 
         }
         else{
          // console.log("?????????????????????????",child, child.props?.children)
          // if (child?.props && Object.keys(child?.props).includes('style')){
          //   axios.post(
          //     "https://translation.googleapis.com/language/translate/v2?key=AIzaSyCMcZ_oG9M6xnr5TLOopvBXw4YC0m61Uw0",
          //     {
          //       q: child.props?.children,
          //       target: language,
          //       source:"en"
          //     },
          //     // {
          //     //   headers: {
          //     //     `,
          //     //   },
          //     // }
          //   ).then(({data})=>setTranslatedText(data.data.translations[0].translatedText)).catch(err=>console.log(err))

          // }
          return  child.props?.children
          
         
         } 
        })
        .filter(Boolean).join(' ')
        const regexastric = /\*/
        const regexQuot=/['"]/g
        // console.log(text)
        if (text.endsWith("*") ){
          text=text.split("*").join(" ")
          setAstric(true)
        }
        else if(text.endsWith("*") &&text.startsWith("*") ){

        }
        let key = "xqL4ldx4jf9McsEJp63TnHYALW1HxIHDr250LtvKdUnWwLoOZ7G3JQQJ99BDACGhslBXJ3w3AAAbACOGcjUU";
        let endpoint = "https://api.cognitive.microsofttranslator.com";
    
        // location, also known as region.
        // required if you're using a multi-service or regional (not global) resource. It can be found in the Azure portal on the Keys and Endpoint page.
        let location = "centralindia";
        axios({
          baseURL: endpoint,
          url: '/translate',
          method: 'post',
          headers: {
              'Ocp-Apim-Subscription-Key': key,
               // location required if you're using a multi-service or regional (not global) resource.
              'Ocp-Apim-Subscription-Region': location,
              'Content-type': 'application/json',
              // 'X-ClientTraceId': uuidv4().toString()
          },
          params: {
              'api-version': '3.0',
              'from': 'en',
              'to': language
          },
          data: [{
              'text': text
          }],
          responseType: 'json'
      }).then(function(response){
          // console.log(response.data[0].translations[0].text)
          setTranslatedText(response.data[0].translations[0].text)
      }).catch(err=>console.log(err))
       

        // axios.post(
        //     "https://translation.googleapis.com/language/translate/v2?key=AIzaSyBRbz5rrkSAwgHwF3WX_8UzPVQHhcgkqUY",
        //     {
        //       q: text,
        //       target: language,
        //       source:"en"
        //     },
        //     // {
        //     //   headers: {
        //     //     `,
        //     //   },
        //     // }
        //   ).then(({data})=>setTranslatedText(data.data.translations[0].translatedText)).catch(err=>console.log(err))
        
    }
    else{
      let text=React.Children.toArray(children).map((child) => {
          
        if( typeof (child) === 'string' ) {
         return child 
        }
        else{
     
         return  child.props?.children
         
        
        } 
       })
       .filter(Boolean).join(' ')
       const regexastric = /\*/
        const regexQuot=/['"]/g
        // console.log(text)
        if (text.endsWith("*") ){
          text=text.split("*").join(" ")
          setAstric(true)
        }
       setTranslatedText(text)
    }
   
},[language,children])

// console.log(style)

return <Typography target={target} color={color} component={component}  to={to} onClick={onClick} sx={{...sx,color:sx?.color?sx?.color:"#212121"}} style={style}>{language=='en'?<HighlightTextInParagraph paragraph={translatedText}/>:<HighlightTextInParagraph paragraph={translatedText}/> }{astric&&<span style={{color:"rgba(255, 122, 122, 1)"}} color='error'>*</span>}</Typography>
{/*  */}

  
};

export const PlaceholderTranslater =({child} ) => {
  console.log("?????????????????????????????????????????????",child)
  const language=localStorage.getItem('language')
  const [astric,setAstric]=useState(false)
  // console.log("children text",children,sx,language)
  let [translatedText,setTranslatedText]=useState("")

  console.log("?????????????????????????????",child)
  useEffect(()=>{
      if (language!='en'){
      // console.log(text)
          let text=React.Children.toArray(child).map((child) => {
            let trans=''
            let transText=""
           if( typeof (child) === 'string' ) {
            trans=child 
           }
           else{
            // console.log("?????????????????????????",child.props?.children)
            trans=  child.props?.children
            
           
           } 
           axios.post(
            "https://translation.googleapis.com/language/translate/v2?key=AIzaSyCMcZ_oG9M6xnr5TLOopvBXw4YC0m61Uw0",
            {
              q: trans,
              target: language,
              source:"en"
            },
          ).then(({data})=> transText=data.data.translations[0].translatedText).catch(err=>console.log(err)) 
          return transText
          })
          .filter(Boolean).join(' ')
          const regex = /\*/
          // console.log(text)
          if (regex.test(text)){
            text=text.split("*").join(" ")
            setAstric(true)
          }
          setTranslatedText(text)
           
      }
  },[language,child])
  // console.log(translatedText,child)
  return language!='en'?translatedText:child 
  };

// export const TranslateSpanText =({children,style,} ) => {
//     const language=localStorage.getItem('language')
//     // console.log("children text",children,language)
//     let [translatedText,setTranslatedText]=useState("")
    
//     useEffect(()=>{
//         if (language!='en'){
//         // console.log(children)
//             let text=React.Children.toArray(children).map((child) => (typeof child === 'string' ? child : null))
//             .filter(Boolean).join(' ')
//             // console.log(text)
          
//                 // console.log(children)
           
//             axios.post(
//                 "https://translation.googleapis.com/language/translate/v2?key=AIzaSyCMcZ_oG9M6xnr5TLOopvBXw4YC0m61Uw0",
//                 {
//                   q: text,
//                   target: 'ta',
//                   source:"en"
//                 },
//                 // {
//                 //   headers: {
//                 //     `,
//                 //   },
//                 // }
//               ).then(({data})=>setTranslatedText(data.data.translations[0].translatedText)).catch(err=>console.log(err))
            
//         }
       
//     },[language])
    
    
    
//     return <span style={style}>{language!='en'?translatedText:children}</span>
    
      
//     };
    
